import { render, staticRenderFns } from "./CenterPanel.vue?vue&type=template&id=22035e7f&scoped=true"
import script from "./CenterPanel.vue?vue&type=script&lang=js"
export * from "./CenterPanel.vue?vue&type=script&lang=js"
import style0 from "./CenterPanel.vue?vue&type=style&index=0&id=22035e7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22035e7f",
  null
  
)

export default component.exports